<script setup lang="ts">
import type { AuthenticationType } from '@/types/auth';

defineProps({
	type: {
		type: Number as PropType<AuthenticationType>,
		default: AUTH_FORM.SIGN_IN,
	},
});

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

const redirectPage = ref();
const isShowGoogleLoginFailDialog = ref(false);

function handleGoogleLoginFailed() {
	isShowGoogleLoginFailDialog.value = true;
}

watch(
	() => authStore.isLoggedIn,
	async (newValue) => {
		if (newValue && route.query?.redirect && route.query.redirect === ROUTE.EVENT_CREATE.NAME) {
			redirectPage.value = AUTH_PAGE_ORIGIN.CREATE;
		}
	},
);

onMounted(() => {
	if (authStore.isLoggedIn) {
		router.replace(ROUTE.INDEX.PATH);
	}
});
</script>

<template>
	<div class="signin-page-container">
		<AuthenticationContainerForm
			:type="type"
			:is-loading="authStore.isLoading"
			:page="redirectPage"
			@on-google-login-failed="handleGoogleLoginFailed"
		/>
		<GoogleLoginFailByInAppBrowserDialog
			:is-show="isShowGoogleLoginFailDialog"
			@on-close="isShowGoogleLoginFailDialog = false"
			@on-confirm="isShowGoogleLoginFailDialog = false"
		/>
	</div>
</template>

<style scoped lang="scss">
.signin-page-container {
	@include media-query-max(mobile) {
		padding: spacings-get(12) spacings-get(4) 0;
	}
}
</style>
